import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import './all.sass';

const TemplateWrapper = ({ children }) => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `}
    render={data => (
      <div>
        <Helmet>
          <html lang="en" />
          <title>{data.site.siteMetadata.title}</title>
          <meta
            name="description"
            content={data.site.siteMetadata.description}
          />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/img/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            href="/img/favicon.ico"
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href="/img/favicon.ico"
            sizes="16x16"
          />

          <link
            rel="mask-icon"
            href="/img/logo.svg"
            color="#ff4400"
          />
          <meta name="theme-color" content="#fff" />

          <meta property="og:type" content="business.business" />
          <meta property="og:title" content={data.site.siteMetadata.title} />
          <meta property="og:url" content="/" />
          <meta property="og:image" content="/img/og-image.jpg" />
          <script>
            {`salessuckers_cid=106; salessuckers_did=157;
            var salessuckers_d='https://wunderpus.azurewebsites.net/client.js';
            (function(d,t) { var s=d.createElement(t); var r=d.getElementsByTagName(t)[0];
              s.src=salessuckers_d;
              s.setAttribute('async', '');
              r.parentNode.insertBefore(s,r)
            }(document,'script'));`}
          </script>
          <meta name="facebook-domain-verification" content="fjngyws05maj4aclkk1k7pllybxboq" />
        </Helmet>
        <div>{children}</div>
      </div>
    )}
  />
);

export default TemplateWrapper;
